/** @format */

import React from 'react';
import 'tailwindcss/dist/base.css';
import Hero from 'components/hero/BackgroundAsImage';
import Feature from 'components/features/VerticalWithAlternateImageAndText';
import Testimonial from 'components/testimonials/ThreeColumnWithProfileImage';
import Faq from 'components/faqs/SingleCol';
import Footer from 'components/footers/SimpleFiveColumn';
import { Help } from 'components/help';
import { Credit } from 'components/credit';
import Contact from 'components/contactform';
import { Brands } from 'components/Brands';

function App() {
	return (
		<>
			<Hero />
			<Help />
			<Credit />
			<Feature />
			<Testimonial />
			<Brands />
			<Faq />
			<Contact />
			<Footer />
		</>
	);
}

export default App;
